import * as React from 'react';
import { Drawer, Icon, Modal } from 'antd';
import { DrawerProps } from 'antd/lib/drawer';
import { RouteComponentProps, withRouter } from "react-router";
import { Link } from "react-router-dom";
import { connect, GlobalProps } from "../../stores/GlobalStore";

import styles from './SideMenu.module.scss';

class SideMenu extends React.PureComponent<DrawerProps & RouteComponentProps<any> & GlobalProps> {
  public render() {
    return (
      <Drawer
        {...this.props}
        width="70%"
        placement="left"
        title="Ciclos"
        bodyStyle={{ padding: 0 }}
      >
        <div className={styles.menu}>
          <Link to="/">
            <div className={styles.menuItem}>
              <Icon type="bars" />
              <span>Início</span>
            </div>
          </Link>
          <div className={`${styles.menuItem} ${styles.logout}`} onClick={this.handleLogoutClick}>
            <Icon type="logout" />
            <span>Logout</span>
          </div>
        </div>
      </Drawer>
    );
  }

  private handleLogoutClick = () => {
    Modal.confirm({
      title: 'Deseja realmente encerrar a seção?',
      content: "Você pode iniciar outra quando quiser.",
      okText: 'Encerrar a seção',
      cancelText: 'Voltar',
      onOk: () => {
        this.props.clearAuthToken();
        this.props.history.push('/login');
      }
    });
  }
}

export default connect(withRouter(SideMenu), 'clearAuthToken');
